import { ApiResult } from '@shared/Interfaces/Api/ApiResult';
import { RawGallery } from '@entities/Gallery/Types';
import ApiRequest from '../../Decorators/ApiRequest';
import { API_DEFAULT_HEADERS } from '@configs/ApiDefaultHeaders';

const BASE_URL = import.meta.env.VITE_BASE_URL_CUSTOMER;

export class GalleryGateway {
    async getGalleriesForFragments(
        fragmentIds: number[]
    ): Promise<ApiResult<RawGallery[]>> {
        const body = {
            type: 'fragment',
            ids: fragmentIds,
        };

        try {
            const response = await ApiRequest(`${BASE_URL}/gallery`, {
                method: 'POST',
                body: JSON.stringify(body),
                headers: API_DEFAULT_HEADERS,
            });

            const json = await response.json();

            if (response.status !== 200 && response.status !== 201) {
                return {
                    error: true,
                    message: 'Failed to fetch galleries for fragments',
                };
            }

            return {
                error: false,
                data: json.data as RawGallery[],
            };
        } catch (error) {
            return {
                error: true,
                message: `Error: ${error}`,
            };
        }
    }
}
